// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"style_playerWrapper__bFSVY","playerWrapperAuto":"style_playerWrapperAuto__1onCo","loader":"style_loader__1fS7j"};